// startup
// Load entry module and return exports
// This entry module used 'module' so it can't be inlined
__webpack_require__("./node_modules/@babel/runtime/regenerator/index.js");
var __webpack_exports__ = __webpack_require__("./src/index.js");
